import { ContractType } from '@/types/commercial/contracts';

export const STANDARD_CONTRACT_TYPES = [
  {
    id: 'sim-card',
    label: 'SIM Card',
    description: 'Contrato padrão para fornecimento e uso de SIM Card.',
  },
  {
    id: 'lora-activation',
    label: 'Ativação LoRa',
    description: 'Contrato padrão para ativação de dispositivos LoRaWan.',
  },
  {
    id: 'platform',
    label: 'Plataforma',
    description: 'Contrato padrão para acesso à plataforma.',
  },
  {
    id: 'technical-services',
    label: 'Serviços Técnicos',
    description: 'Contrato padrão para prestação de serviços técnicos.',
  },
] as const;

export type StandardContractTypeId = (typeof STANDARD_CONTRACT_TYPES)[number]['id'];

interface StandardContractType {
  id: StandardContractTypeId;
  label: string;
  description: string;
}

export interface StandardContractView extends StandardContractType {
  contractId: string | null;
  version: string | null;
  active: boolean | null;
}

const CONTRACT_TYPE_MAP: Record<StandardContractTypeId, ContractType> = {
  'sim-card': ContractType.SIM_CARD,
  'lora-activation': ContractType.LORA_ACTIVATION,
  platform: ContractType.PLATFORM,
  'technical-services': ContractType.TECHNICAL_SERVICES,
};

export function toApiContractType(id: StandardContractTypeId): ContractType {
  return CONTRACT_TYPE_MAP[id];
}

export function fromApiContractType(type: ContractType): StandardContractTypeId {
  const entry = Object.entries(CONTRACT_TYPE_MAP).find(([, value]) => value === type);
  return (entry?.[0] ?? 'sim-card') as StandardContractTypeId;
}
